"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Baobab_Components_1 = require("../registry/Baobab-Components");
function withBaobab(nodeDeclaration, WrappedComponent) {
    var baobabHoc = function (Component) {
        var componentName = Component.displayName || Component.name || 'Component';
        var BaobabWrapper = function (_a) {
            var ref = _a.__forwardedRef__, logNode = _a.logNode, originalProps = __rest(_a, ["__forwardedRef__", "logNode"]);
            return (React.createElement(Baobab_Components_1.BaobabComponents.Consumer, null, function (_a) {
                var BaobabNode = _a.BaobabNode;
                return (React.createElement(BaobabNode, { nodeDeclaration: nodeDeclaration, logNode: logNode, childProps: originalProps }, function (props) { return React.createElement(Component, __assign({}, originalProps, props, { ref: ref })); }));
            }));
        };
        BaobabWrapper.displayName = "AddBaobab(" + componentName + ")";
        if (nodeDeclaration.extra && nodeDeclaration.extra.ref) {
            var BaobabWithForwardRef = React.forwardRef(function (props, ref) { return (React.createElement(BaobabWrapper, __assign({}, props, { __forwardedRef__: ref }))); });
            BaobabWithForwardRef.displayName = "AddBaobab(" + componentName + ")";
            return BaobabWithForwardRef;
        }
        return BaobabWrapper;
    };
    return WrappedComponent ? baobabHoc(WrappedComponent) : baobabHoc;
}
exports.withBaobab = withBaobab;
